import { Box, Button } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getDictionary } from "../features/dictionary/dictionary.service";

import { alphabet } from "../features/dictionary/assets/alphabet";
import { DictionaryElement } from "../features/dictionary/components/dictionary-element";
import { EltrpHeader } from "../layout/wrappers/eltrp-header";
import { EltrpPage } from "../layout/wrappers/eltrp-page";
import { EltrpBody } from "../layout/wrappers/eltrp-body";
import { EltrpLoading } from "../layout/wrappers/eltrp-loading";

export const DictionaryPage = () => {
  const [dictionaryJSON, setDictionaryJSON] = useState({});
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const state = location.state as any;

  useEffect(() => {
    setLoading(true);
    getDictionary(setLoading).subscribe((a) => {
      setLoading(false);
      setDictionaryJSON(a);
    });
  }, [state]);

  useEffect(() => {
    if (state !== null) {
      const s = document.getElementById(state.subject);
      s?.scrollIntoView({ block: "center" });
      window.history.replaceState({}, document.title);
    }
  }, [state, dictionaryJSON]);

  const onLetterClick = (e: any) => {
    const s = document.getElementById(e);
    s?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <EltrpPage metaTitle={"ELTRP Dictionary"} metaDescription={"Definitions of commonly used terms related to recycled tyre rubber. As many of the reports on this portal contain technical language and industry-specific vocabulary, the Dictionary aims to support readers by offering clear explanations of key concepts. Whether you're new to the field or simply need a quick reference, this resource is designed to help you better understand the terminology used throughout the portal."}>
      <EltrpLoading loading={loading} />
      <EltrpHeader title={"DICTIONARY"}>
        <Grid2 xs={10} xsOffset={1} sm={8} smOffset={2}>
          <p>This page provides definitions of commonly used terms related to recycled tyre rubber. As many of the reports on this portal contain technical language and industry-specific vocabulary, the Dictionary aims to support readers by offering clear explanations of key concepts. Whether you're new to the field or simply need a quick reference, this resource is designed to help you better understand the terminology used throughout the portal.</p>
        </Grid2>
        <Grid2 textAlign={"center"} className={"dictionaryHeader"} mb={4}>
          {alphabet.map((letter) => (
            <Box
              display={"inline-flex"}
              height={30}
              width={30}
              justifyContent="center"
              alignItems={"center"}
            >
              <p
                className={
                  dictionaryJSON &&
                  Object.keys(dictionaryJSON)
                    .map((m) => m[0])
                    .includes(letter)
                    ? "letterActive"
                    : "letterDisabled"
                }
                key={letter + "2"}
                onClick={() => onLetterClick(letter)}
              >
                {" "}
                {letter}{" "}
              </p>{" "}
            </Box>
          ))}
          <br />
        </Grid2>
      </EltrpHeader>
      <EltrpBody>
        <Grid2
          xs={12}
          container
          display="flex"
          justifyContent="center"
          className="dictionaryBody"
        >
          {Object.keys(dictionaryJSON)
            .map((m) => m[0])
            .filter((v, i, a) => a.indexOf(v) === i)
            .map((letter: string) => (
              <Grid2
                columnGap={5}
                rowGap={5}
                container
                justifyContent="center"
                key={letter}
                textAlign="center"
              >
                <DictionaryElement
                  letterT={letter}
                  dictionaryJSON={dictionaryJSON}
                />
              </Grid2>
            ))}
        </Grid2>
        <Grid2 xs={12} textAlign={"center"} mt={5} mb={5}>
          <Button
            color={"secondary"}
            variant={"outlined"}
            onClick={() =>
              document
                .getElementById("top")
                ?.scrollIntoView({ behavior: "smooth" })
            }
          >
            Return To Top
          </Button>
        </Grid2>
      </EltrpBody>
    </EltrpPage>
  );
};
